export default __webpack_public_path__ + "static/media/868.3370849e.gif";